import { render, staticRenderFns } from "./TestSendSms.vue?vue&type=template&id=684a4997"
import script from "./TestSendSms.vue?vue&type=script&lang=js"
export * from "./TestSendSms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports